module.exports = "<div class=\"d-block w-graph\" [style.height.px]=\"heightSize\" [class.w-print]=\"printing\">\n    <canvas [id]=\"element\"></canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/charts/chart-donut/chart-donut.component.html
// module id = ./src/app/components/tools/charts/chart-donut/chart-donut.component.html
// module chunks = main